import { render, staticRenderFns } from "./CarPassport.vue?vue&type=template&id=2bd16650&scoped=true"
import script from "./CarPassport.vue?vue&type=script&lang=js"
export * from "./CarPassport.vue?vue&type=script&lang=js"
import style0 from "./CarPassport.vue?vue&type=style&index=0&id=2bd16650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd16650",
  null
  
)

export default component.exports